<app-template-controller *ngIf="editable && isEditIndex"></app-template-controller>
<div class="template_040" id="top" tabindex="-1" [style.margin-top.px]="editable ? 60 : 0" #pageTopAnchor>
  <a *ngIf="isIndex; else another" href="#index_main" pageScroll class="sr-only sr-only-focusable" title="{{'guideTile.toModdle' | translate}}" (click)="focusContentKey()">{{'guideTile.toModdle' | translate}}</a>
  <ng-template #another>
    <a href="#main_content" pageScroll class="sr-only sr-only-focusable" title="{{'guideTile.toModdle' | translate}}" (click)="focusContentKey()">{{'guideTile.toModdle' | translate}}</a>
  </ng-template>

  <header>
    <!-- LOGO -->
    <div class="col-md-12 logo" [class.disableClick]="editable">
      <a href="#top" pageScroll title="{{'guideTile.top' | translate}}" class="key" accesskey="U">:::</a>
      <h1>
        <a class="navbar-brand" routerLink="./" title="{{siteInfo?.metadata?.title}}">
          <img src="{{logoImageFile && logoImageFile.url || '/assets/images/logo2.png'}}" alt="{{siteInfo?.metadata?.title}}" width="252" height="60"
          tmErrorDefaultImage="/assets/images/logo2.png"/>
        </a>
      </h1>
    </div>
    <!-- /.LOGO -->

    <!-- 搜尋、導航、語系 -->
    <nav class="navbar navbar-default navbar-top" [class.disableClick]="editable" attr.aria-label="{{'navigation_bar' | translate}}">
      <div class="container-fluid justify-content-end">
        <ul class="nav-fit">
          <!-- 搜尋 -->
          <li id="searchToolItem">
            <form class="navbar-form">
              <div class="input-group stylish-input-group">
                <label id="media_searchId" for="search" class="none"> {{'searchToolModal.searchMaterial' | translate}}： </label>
                <span class="search-submit search-selector">
                  <a role="button" href="#searchToolModal" data-toggle="modal" data-target="#searchToolModal" title="{{'searchToolModal.openOrCloseSearchModal' | translate}}">
                    <span class="fa fa-search" aria-hidden="true"></span>
                    <span class="sr-only">{{'searchToolModal.openOrCloseSearchModal' | translate}}</span>
                  </a>
                </span>
              </div>
            </form>
          </li>
          <!-- /.搜尋 -->
          <li class="pc" *ngIf="metadata && metadata.index"><a routerLink="./">{{'toHome'| translate}} </a></li>
          <li class="pc" *ngIf="metadata && metadata.sitemap"><a routerLink="./sitemap">{{'sitemap'| translate}} </a></li>
          <!-- 語系 -->
          <li class="lang pc" >
            <a href="javascript: void(0)" role="button" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false" [tmCloseOnContainerBlur]="langDDMenu">
              <!-- <span>{{(currentLang | translate | uppercase) | slice: 0 : 2}}</span> <b class="caret"></b> -->
              <span><i class="fa fa-language" aria-hidden="true"></i></span> <b class="caret"></b>
            </a>
            <div class="dropdown-menu langList" aria-labelledby="lang_dropdown" #langDDMenu>
              <ng-container  *ngFor="let lang of langs">
                <a class="dropdown-item" href="javascript:void(0)" (click)="goTranslate(lang)"><span class="notranslate">{{lang | translate}}</span></a>
              </ng-container>
            </div>
          </li>
          <!-- /.語系 -->
          <app-member-loging-button #memberLoginBtn></app-member-loging-button>
          <!-- google_translate_element -->
          <!-- *ngIf="metadata && metadata.googleTranslateView" -->

          <li id="google_translate_element" class="googleTranslateElement" style="width: 74px;height:23px;line-height: 23px;" *ngIf="narBar && narBar.googleTranslateView"></li>
        </ul>
      </div>
    </nav>
    <!-- /.搜尋、導航、語系 -->
    <!-- 選單區塊 -->
    <nav class="navbar navbar-expand-lg navbar-style" [class.disableClick]="editable || !menus" attr.aria-label="{{'Site_menu' | translate}}">
      <button class="navbar-toggler collapsed" data-toggle="collapse" data-target="#navbarHeadMenu"
      aria-controls="navbarHeadMenu" aria-expanded="false" attr.aria-label="{{'openOrCloseMainMenu' | translate}}" #mbMenuToggler>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarHeadMenu">
        <div class="col-md-12 site2" menu-head>
          <div class="sitetab-list">
            <div class="c-tab"><a routerLink="./subject">{{'subjectPage.title' | translate}}</a></div>
            <div class="c-tab"><a routerLink="./explore">{{'explorePage.title' | translate}}</a></div>
            <div class="c-tab"><a routerLink="./interact">{{'quiz.title' | translate}}</a></div>
            <div class="c-tab"><a routerLink="./participate">{{'participatePage.title' | translate}}</a></div>
            <div class="c-tab"><a routerLink="./curation">{{'curating' | translate}}</a></div>
          </div>
        </div>
        <!-- 選單 -->
        <app-menu [menu]="menus" [limit]="2">
          <li class="nav-item pc" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" menu-head *ngIf="metadata && metadata.index">
            <a class="nav-link" routerLink="./">{{'home' | translate}}</a>
          </li>

          <li class="nav-item pc" routerLinkActive="active" menu-head>
            <a class="nav-link" routerLink="./subject">{{'subjectPage.title' | translate}}</a>
          </li>

          <li class="nav-item pc" routerLinkActive="active" menu-head>
            <a class="nav-link" routerLink="./explore">{{'explorePage.title' | translate}}</a>
          </li>

          <li class="nav-item pc" routerLinkActive="active" menu-head>
            <a class="nav-link" routerLink="./interact">{{'quiz.title' | translate}}</a>
          </li>

          <li class="nav-item pc" routerLinkActive="active" menu-head>
            <a class="nav-link" routerLink="./participate">{{'participatePage.title' | translate}}</a>
          </li>

          <li class="nav-item pc" routerLinkActive="active" menu-head>
            <a class="nav-link" routerLink="./curation">{{'curating' | translate}}</a>
          </li>

          <li class="nav-item pc" menu-end>
            <button class="navbar-toggler collapsed"
            (click)="menuCollapseSt.show();"
            aria-controls="navbarMainMenu" attr.aria-expanded="{{menuCollapseSt.isShow}}" attr.aria-label="{{'openMainMenu' | translate}}"
            [tmCloseOnContainerBlur]="mainMenu" #mainMenuCcb="tmCCB"
            #menuOpenBtn>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
          </li>
        </app-menu>
        <!-- /.選單 -->

        <ul class="navbar-nav nav-menu2">
          <li class="nav-item dropdown lang mb" *ngIf="metadata && metadata.showLang && langs.length != 1">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false" id="lang_dropdown"
            [tmCloseOnContainerBlur]="langDDMenu2">
              {{(currentLang | translate | uppercase) | slice: 0 : 2}}
            </a>
            <div class="dropdown-menu" aria-labelledby="lang_dropdown" #langDDMenu2>
              <ng-container *ngFor="let lang of langs"><a href="/{{lang}}" class="dropdown-item">{{(lang | translate | uppercase) | slice: 0:2}}</a></ng-container>
            </div>
          </li>

          <ng-container *ngIf="memberLoginBtn" menu-head>
            <ng-container *ngIf="memberLoginBtn.hasLoginSys">
              <li class="mb"
              [class.member-loading]="memberLoginBtn.loginIng"
              [class.member-show]="memberLoginBtn.memberInfo"
              [class.dropdown]="memberLoginBtn.memberInfo">
                <a href="javascript:void(0)" (click)="memberLoginBtn.openCultureCenterLogin()" role="button"
                title="{{'openLoginWindow' | translate}}[{{'openNewWindow' | translate}}]" *ngIf="!memberLoginBtn.memberInfo">
                  <i class="fa fa-user" aria-hidden="true"></i>
                  <span *ngIf="!memberLoginBtn.memberInfo"> {{'login' | translate}}</span>
                </a>
                <ng-container *ngIf="memberLoginBtn.memberInfo">
                  <a href="javascript:void(0)" class="dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                    <i class="fa fa-user" aria-hidden="true"></i>
                    {{ 'hello' | translate: ({value: memberLoginBtn.memberInfo.name}) }}
                  </a>
                  <div class="dropdown-menu">
                    <a class="dropdown-item mb nav-link" [routerLink]="[memberLoginBtn.toHomePath, 'memberCollection']" routerLinkActive="active">我的收藏</a>
                    <a class="dropdown-item mb nav-link" role="button" tabindex="0" (click)="memberLoginBtn.openPrefere()">內容偏好</a>
                    <a class="dropdown-item mb nav-link member-logout-btn" role="button" tabindex="0" (click)="memberLoginBtn.logout()">登出 <i class="fa fa-sign-out fa-fw "></i></a>
                  </div>
                  <app-member-preference-modal></app-member-preference-modal>
                </ng-container>
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </nav>

    <div class="collapse pc-fix-menu menu_bg" id="navbarMainMenu" #mainMenu tabindex="-1"
    appBsCollapse #menuCollapseSt="bsCollapse" (shown)="menuCloseBtn.focus();" (hidden)="menuOpenBtn.focus();" (keydown.esc)="menuToggler.click()">
      <button class="navbar-toggler collapsed"
      (click)="menuCollapseSt.toggle();"
      aria-controls="navbarMainMenu" attr.aria-expanded="{{menuCollapseSt.isShow}}" attr.aria-label="{{'closeMainMenu' | translate}}"
      #menuToggler
      #menuCloseBtn>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <!-- <button type="button" class="close" aria-label="關閉主選單">
        <span aria-hidden="true">×</span>
      </button> -->
      <div class="p-h-md menuDiv" (click)="onClickMenuDiv($event, menuToggler)">
        <div class="container-fluid">
          <ng-container *ngTemplateOutlet="menuTmp; context: {$implicit: menus}"></ng-container>
        </div>
      </div>
    </div>
    <!-- /.選單區塊 -->
  </header>

  <!-- 內容區塊 -->
  <div id="index_main">
    <!-- 主要內容區塊的guideTile -->
    <a *ngIf="isIndex ; else anotherPage" href="#index_main" pageScroll [class.disableClick]="editable" title="{{'guideTile.middle' | translate}}" class="key" accesskey="C" #contentAnchor>:::</a>
    <ng-template #anotherPage>
      <a id="main_content" href="#main_content" pageScroll [class.disableClick]="editable" title="{{'guideTile.middle' | translate}}" class="key" accesskey="C" #contentAnchor style="top: 10px;">:::</a>
    </ng-template>
    <!-- /主要內容區塊的guideTile -->

    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- /.內容區塊 -->

  <!-- 表尾資訊 -->
  <footer id="footer">
    <a href="#footer" pageScroll title="{{'guideTile.bottom' | translate}}" class="key" [class.disableClick]="editable" accesskey="B">:::</a>

    <!--footer site-->
    <app-footer-controler *ngIf="editable"></app-footer-controler>
    <ng-container *ngIf="editable || showFooter">
      <ng-container *ngTemplateOutlet="menuTmp; context: {$implicit: footerSiteMap}"></ng-container>
    </ng-container>

    <ng-container *ngIf="footer">
      <div class="row area2" [class.disableClick]="editable" *ngIf="footer.content">
        <div class="col-lg-10 col-lg-offset-1 col-md-12 copyright">
          <div class="fr-view" [innerHtml]="$any(footer.content | safe: 'html')" *ngIf="footer.content"></div>
        </div>
      </div>
      <div class="row" [class.disableClick]="editable" *ngIf="footer.enableAccessibility && footer.accessibilityContent">
        <div class="col">
          <div [innerHtml]="$any(footer.accessibilityContent | safe: 'html')"></div>
        </div>
      </div>
    </ng-container>

    <a href="#top" pageScroll class="back-top" title="{{'toTop' | translate}}" [@fadeInOut]="showGoTop" (click)="setFocusTop()"><span>{{'toTop' | translate}}</span></a>
  </footer>
</div>

<ng-template #menuTmp let-data>
  <div class="row area1" [class.disableClick]="editable">
    <div class="col-lg-10 col-lg-offset-1 col-md-12 site">
      <div class="sitetab-list">
        <div class="c-tab"><a routerLink="./subject">{{'subjectPage.title' | translate}}</a></div>
        <div class="c-tab"><a routerLink="./explore">{{'explorePage.title' | translate}}</a></div>
        <div class="c-tab"><a routerLink="./interact">{{'quiz.title' | translate}}</a></div>
        <div class="c-tab"><a routerLink="./participate">{{'participatePage.title' | translate}}</a></div>
        <div class="c-tab"><a routerLink="./curation">{{'curating' | translate}}</a></div>
      </div>
    </div>
    <div class="col-lg-10 col-lg-offset-1 col-md-12 site" *ngIf="data">
      <dl class="" *ngFor="let siteItem of data">
        <dt>
          <ng-container *ngIf="siteItem.module == 'LINKING'">
            <a title="{{siteItem.title}}[{{'openNewWindow' | translate}}]" href="{{siteItem?.otherSetting.url}}" target="_blank">{{siteItem.title}}</a>
          </ng-container>
          <ng-container *ngIf="siteItem.module != 'LINKING'">
            <span *ngIf="siteItem.module == 'EMPTY'">{{siteItem.title}}</span>
            <a *ngIf="siteItem.module != 'EMPTY'" title="{{siteItem.title}}" routerLink="./{{siteItem.path | appPath}}">{{siteItem.title}}</a>
          </ng-container>
        </dt>
        <ng-container *ngIf="siteItem.menus?.length > 0">
          <dd *ngFor="let subSiteItem of siteItem.menus">
            <ng-container *ngIf="subSiteItem.module == 'LINKING'">
              <a title="{{subSiteItem.title}}[{{'openNewWindow' | translate}}]" href="{{subSiteItem?.otherSetting.url}}" target="_blank">{{subSiteItem.title}}</a>
            </ng-container>
            <ng-container *ngIf="subSiteItem.module != 'LINKING'">
              <span *ngIf="subSiteItem.module == 'EMPTY'">{{subSiteItem.title}}</span>
              <a *ngIf="subSiteItem.module != 'EMPTY'" title="{{subSiteItem.title}}" routerLink="./{{subSiteItem.path | appPath}}">{{subSiteItem.title}}</a>
            </ng-container>
          </dd>
        </ng-container>
      </dl>
    </div>
    <!--/.footer site-->
  </div>
</ng-template>

<app-search-tool-modal></app-search-tool-modal>

<!-- <tm-modal [modalConfig]="{disableClose: true, hasBackdrop: true, width: '600px', position: { top: '20vh' }}"
[showClose]="false" [okBtnLabel]="false" [cancelBtnLabel]="false"
title="網站維護公告" panelClass="share-social-modal" #bulletinModal >
  <tm-modal-header></tm-modal-header>
  <tm-modal-body>
    <div class="f3f3f3" #tmModalBody>
      <div class="col-md-12 social">
        本網站預計7/3-7/8進行系統維護作業，受影響之服務範圍包括：「主題」專區、「參與」專區暫停服務，首頁亦僅提供素材搜尋服務。維護期間仍可繼續使用網站，造成不便，敬請見諒。
      </div>
    </div>
  </tm-modal-body>
  <tm-modal-footer>
    <button type="button" class="btn btn-default" data-dismiss="modal" (click)="closeBulletin()">{{'modal.ok' | translate}}</button>
  </tm-modal-footer>
</tm-modal> -->
